import React, { useEffect, useState } from "react";
import { maklersService } from "../../../../service/maklersService";
import { UserPunktePoPup } from "./UserPunktePoPup";
import { useParams } from "react-router-dom";
import BTableHeader from "../../../../components/tables/BTableHeader";
import { BsPencilSquare } from "react-icons/bs";

const UserPunktePage = () => {
  const { id } = useParams();

  const [points, setPoints] = useState();
  const [isPopUpVisible, setIsPopUpVisible] = useState(false);
  const [newPoint, setNewPoint] = useState();
  const [newDistrict, setNewDistrict] = useState();

  useEffect(() => {
    if (isPopUpVisible) return;

    maklersService.getMaklerPointsById(id).then((res) => {
      setPoints(res.data);
    });
  }, [id, isPopUpVisible]);

  const saveChange = () => {
    maklersService
      .saveMaklerPointsById(id, {
        points: Number(newPoint),
        districtId: newDistrict.id,
      })
      .then(() => setIsPopUpVisible(false))
      .catch((error) => {
        alert(error);
      });
  };

  return (
    <div className="p-6">
      <BTableHeader header={"Punkte"} />
      <div className="bg-white rounded shadow-md w-full flex flex-col border-gray-400 py-2 px-3 mt-6">
        <div className="mt-8 flex justify-around items-stretch w-full">
          {points ? (
            <>
              <PointsTableColumn
                headerText="District"
                items={points.map((x) => x.district && x.district.name)}
              />
              <PointsTableColumn
                headerText="Points"
                items={points.map((x) => x.points)}
              />
              <PointsTableColumn
                headerText="Edit"
                items={points.map((x) => (
                  <button
                    onClick={() => {
                      setIsPopUpVisible(true);
                      setNewDistrict(x.district);
                      setNewPoint(x.points);
                    }}
                  >
                    <BsPencilSquare />
                  </button>
                ))}
              />
            </>
          ) : (
            <div>Loading</div>
          )}

          {isPopUpVisible === true ? (
            <UserPunktePoPup
              setIsPopUpVisible={setIsPopUpVisible}
              newPoint={newPoint}
              districtName={newDistrict.name}
              setNewPoint={setNewPoint}
              saveChange={saveChange}
            />
          ) : (
            ""
          )}
        </div>
      </div>
    </div>
  );
};

const PointsTableColumn = ({ headerText, items }) => {
  return (
    <div class="flex flex-col text-center">
      <div className="font-bold">{headerText}</div>
      <div>{items && items.map((x) => x !== undefined && <div className="w-full mt-2">{x}</div>)}</div>
    </div>
  );
};

export default UserPunktePage;
